module.exports = __webpack_public_path__ + "images/264061b6f7b730358413a16461a1f5cc.png";